import groupBy from 'lodash/groupBy'
import mapKeys from 'lodash/mapKeys'
import camelCase from 'lodash/camelCase'
import { dayjsUtc, londonToday } from 'lib/dayjs'

import { getDateFromParts } from 'lib/formik/dates'
import { DEATH } from './fact-find/people/field-names'

export const formatDate = (date) => {
  if (!date) return null
  return date?.format('D MMM YYYY')
}

export const getDateOfDeath = (values) => {
  return getDateFromParts({ prefix: DEATH, values })
}

export const groupProbateEstateItems = (items) => {
  return mapKeys(groupBy(items, 'attributes.itemType'), (_, key) =>
    camelCase(key)
  )
}

export const getDateOfDeathIsOnOrAfter20200206 = (values) => {
  const dateOfDeath = getDateOfDeath(values)
  if (!dateOfDeath) return null
  return dateOfDeath.isSameOrAfter(dayjsUtc('2020-02-06'), 'day')
}

export const getDateOfDeathIsOnOrAfter20100406 = (values) => {
  const dateOfDeath = getDateOfDeath(values)
  if (!dateOfDeath) return null
  return dateOfDeath.isSameOrAfter(dayjsUtc('2010-04-06'), 'day')
}

export const getDateIsOnOrAfter19741113 = (date) => {
  if (!date) return null
  return date.isSameOrAfter(dayjsUtc('1974-11-13'), 'day')
}

export const getIsOverEighteen = (date) => {
  if (!date) return null
  const years = dayjsUtc(londonToday()).diff(date, 'year')
  return years >= 18
}
